import api from './api';
import { unwrapList } from './unwrapList';
import { Tag, TagFormData } from '../types/tag';

export const tagService = {
    // Get all tags
    getTags: async (): Promise<Tag[]> => {
        const response = await api.get('/tags');
        return unwrapList<Tag>(response.data);
    },

    // Create a new tag
    createTag: async (data: TagFormData): Promise<Tag> => {
        const response = await api.post('/tags', data);
        return (response.data as any).data;
    },

    // Update a tag
    updateTag: async (id: number, data: TagFormData): Promise<Tag> => {
        const response = await api.put(`/tags/${id}`, data);
        return (response.data as any).data;
    },

    // Delete a tag
    deleteTag: async (id: number): Promise<void> => {
        await api.delete(`/tags/${id}`);
    },

    // Attach tags to an image
    attachTagsToImage: async (imageId: number, tagIds: number[]): Promise<any> => {
        const response = await api.post(`/images/${imageId}/tags`, { tag_ids: tagIds });
        return (response.data as any).data;
    },

    // Detach a tag from an image
    detachTagFromImage: async (imageId: number, tagId: number): Promise<any> => {
        const response = await api.delete(`/images/${imageId}/tags/${tagId}`);
        return (response.data as any).data;
    },

    // Sync tags for an image (replace all)
    syncTagsForImage: async (imageId: number, tagIds: number[]): Promise<any> => {
        const response = await api.put(`/images/${imageId}/tags`, { tag_ids: tagIds });
        return (response.data as any).data;
    }
};

export default tagService;
